export default "__VITE_ASSET__029b18e9__"